import React, { useState, useEffect, useCallback } from 'react'
import Pagination from "react-js-pagination";
import { useDispatch, useSelector } from 'react-redux';
import { getInvitedPatients, createUser, updateUser } from '../store/slices/hcpSlice';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import debounce from 'lodash/debounce'

import { swalDel, Toast } from '../utils/SwalUti';
import { del, post } from '../utils/fetchAPI';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faEdit, faTrash} from '@fortawesome/free-solid-svg-icons'


function PendingRequest() {
  const dispatch = useDispatch()
  const { invitedPatients, pagination, isLoading } = useSelector(state => state.hcp)
  const hcpID = useSelector(state => state.auth.user.hcp._id)
  const [length, setLength] = useState(10)
  const [searchQuery, setSearchQuery] = useState('')
  const initialState = {
    _id: "",
    email: "",
    hcp: ""
  };
  const [errorMessage, setErrorMessage] = useState('')
  const [formData, setFormData] = useState(initialState)
  const [patientEmailUpdateModalShow, setPatientEmailUpdateModalShow] = useState(false)
  const { current_page, per_page, total } = pagination

  function handleChange(evt) {
    setFormData({
      ...formData,
      [evt.target.name]: evt.target.value
    });
  }

  const handleClose = () => {
    setPatientEmailUpdateModalShow(false)
  };


  const updatePatientEmail = (e) => {
    e.preventDefault();
    // handle user edit process
    dispatch(updateUser(formData))
        .then(_ => {
          setPatientEmailUpdateModalShow(false)
          index(current_page)
          Toast.fire({
            icon: 'success',
            title: 'Updated successfully'
          })
        })
  }

  const handleEditModal = (id) => {
    const { _id, email } = invitedPatients.find(staff => staff._id === id)
    setFormData({ _id, email })
    setPatientEmailUpdateModalShow(true)
  };

  const InvitePatient = (id) => {
    // invite email logic here
    const { _id, email , access} = invitedPatients.find(staff => staff._id === id)

    post('/mail-pending-patient', { _id, email , access})
        .then(res => {
          Toast.fire({
            icon: 'success',
            title: 'Invitation sent!'
          })
        })
        .catch(err => setErrorMessage(err.response.data.message))
  }

  const handleDelete = (id) => {
    swalDel('This entity would be deleted permanently!')
        .then((result) => {
          if (result.value) {
            del(`/user/${id}`)
                .then(_ => {
                  Toast.fire({
                    icon: 'success',
                    title: 'Deleted!'
                  })
                  index(current_page)
                })
                .catch(error => {
                  console.log(error);
                })
          }
        })
  }

  const index = (page = 1) => {
    dispatch(getInvitedPatients({ page: page, per_page: length, search: searchQuery }))
  }
  const delayedQuery = useCallback(debounce(index, 500), [searchQuery, length])

  useEffect(() => {
    delayedQuery();
    return delayedQuery.cancel;
  }, [searchQuery, delayedQuery, length]);

  return (
      <div className="content-wrapper">
        <section className="content pt-3">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <div className="float-left">
                      <h2 className="card-title pt-1"> Pending Requests </h2>
                      <a href='' className="ml-4 card-title">
                        {
                          isLoading ?
                              (
                                  <div className="loader"></div>
                              )
                              : ''
                        }
                      </a>
                    </div>
                    <div className="float-right">
                      <div className="input-group" >
                        <input value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="form-control form-control-sm" type="text" placeholder="Search" />
                      </div>
                    </div>
                  </div>
                  {/* /.card-header */}
                  <div className="card-body" style={{ overflowX: 'auto' }} >

                    <table id="example2" className="table table-hover table-sm table-responsive{-sm|-md|-lg|-xl}">
                      <thead>
                      <tr>
                        <th>Email</th>
                        <th>Method</th>
                        <th>Date</th>
                        <th className="text-center" >ACTIONS</th>
                      </tr>
                      </thead>
                      <tbody>
                      {!!invitedPatients && invitedPatients.map((data, index) => (
                          <tr key={index} >
                            <td>{data.email}</td>
                            <td>email</td>
                            <td>{new Date(data.createdAt).toLocaleDateString()}</td>
                            <td className="text-center" >
                              <div className="btn-group btn-group-sm" role="group" aria-label="single group">
                                <button type="button" className="btn btn-sm" onClick={() => InvitePatient(data._id)} >
                                  <FontAwesomeIcon icon={faEnvelope} className='text-primary'/>
                                </button>
                                <button type="button" className="btn btn-sm" onClick={() => handleEditModal(data._id)} >
                                  <FontAwesomeIcon icon={faEdit} className='text-green'/>
                                </button>
                                <button type="button" className="btn btn-sm" onClick={() => handleDelete(data._id)} >
                                  <FontAwesomeIcon icon={faTrash} className='text-red'/>
                                </button>
                              </div>
                            </td>
                          </tr>
                      ))
                      }
                      </tbody>
                    </table>

                    {/* invited patient email edit modal starts */}
                    <Modal
                        show={patientEmailUpdateModalShow}
                        onHide={handleClose}
                        backdrop="static"
                        keyboard={false}
                    >
                      <Modal.Header closeButton className='pb-2' >
                        <Modal.Title>Modify Patient Email</Modal.Title>
                      </Modal.Header>
                      <form onSubmit={updatePatientEmail}>
                        <Modal.Body>
                          <div className="form-row">
                            <h5 className='text-center'>Please confirm the patient’s email below and submit.</h5>

                            <div className="mt-3 form-group col-md-12 px-3">
                              <input type="email" name="email" className="form-control" value={formData.email} onChange={handleChange} required />
                              {errorMessage ? <span className="text-danger mt-2">{errorMessage}</span> : null}
                            </div>
                          </div>

                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="secondary" onClick={handleClose}>
                            Close
                          </Button>
                          <Button variant="primary" type="submit">Submit</Button>
                        </Modal.Footer>
                      </form>
                    </Modal>
                    {/* invited patient email edit modal ends here */}

                  </div>
                  {/* /.card-body */}
                  <div className="card-footer">
                    <div className="float-left">
                      <div className="dataTables_info" id="example2_info" role="status" aria-live="polite">
                        {/* <div className="float-left">
                      </div> */}
                        {
                          !!invitedPatients.length > 0 ?
                              (
                                  <>
                                    <select onChange={(e) => setLength(e.target.value)}>
                                      <option value={10}>10 entries </option>
                                      <option value={20}>20 entries </option>
                                      <option value={50}>50 entries </option>
                                      <option value={100}>100 entries </option>
                                    </select> &nbsp;
                                    Showing {((current_page - 1) * per_page) + 1} to {total > current_page * per_page ? current_page * per_page : total} of {total} entries
                                  </>
                              )
                              :
                              null
                        }
                      </div>
                    </div>
                    <div className="float-right">
                      <Pagination
                          activePage={parseInt(current_page)}
                          itemsCountPerPage={parseInt(per_page)}
                          totalItemsCount={parseInt(total)}
                          // pageRangeDisplayed={5}
                          onChange={(current_page) => index(current_page)}
                          itemClass="page-item"
                          linkClass="page-link"
                      />
                    </div>
                  </div>
                </div>
                {/* /.card */}
              </div>
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </section>
      </div>
  )
}

export default PendingRequest